var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"loading":_vm.loading,"disabled":_vm.disabled,"color":"primary","small":""},on:{"click":_vm.startInspection}},[(_vm.getIcon)?_c('v-icon',{attrs:{"color":"white"}},[_vm._v("\n    "+_vm._s(_vm.getIcon)+"\n  ")]):_vm._e(),_vm._v("\n  "+_vm._s(_vm.getButtonText)+"\n")],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7af0cd60","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InspectionBtn.vue
// module id = null
// module chunks = 